import React from "react";
import { Controller } from "react-hook-form";
import styles from "./SelectablePills.module.scss";
import withLabelAndError from "../withLabelAndError";
import { combineClasses } from "@/lib/utils";
import {
  InputControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";

type Option = {
  label: string;
  value: string;
  selectedColor?: string;
};

interface SelectablePillsProps extends InputControlProps {
  options: Option[];
  pillClassName?: string;
  roundedFull?: boolean;
}

const SelectablePills: React.FC<SelectablePillsProps> = (props) => {
  const {
    control,
    register,
    validations,
    name,
    options = [],
    error,
    className,
    pillClassName,
    roundedFull = false,
  } = props;

  const renderPills = (field: any = {}) => {
    const { value, onChange } = field;

    return (
      <div className={combineClasses(styles.wrapper, className)}>
        {options.map((opt) => {
          const isSelected = value === opt.value;

          const defaultGrey = "#ededed";
          const selectedColor = opt.selectedColor || "red";

          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange?.(opt.value)}
              className={combineClasses(
                styles.pill,
                roundedFull && styles.roundedFull,
                isSelected && styles.active,
                error && styles.error,
                pillClassName,
              )}
              style={{
                borderColor: isSelected ? selectedColor : defaultGrey,
                color: isSelected ? selectedColor : "black",
                backgroundColor: isSelected
                  ? `${selectedColor}15`
                  : defaultGrey,
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    );
  };

  // RHF Controller mode
  if (control) {
    return (
      <Controller
        control={control}
        name={name}
        rules={validations}
        render={({ field }) => renderPills(field)}
      />
    );
  }

  // Register mode
  const field = register?.(name, validations);
  return renderPills({
    ...field,
    onChange: (val: string) => {
      field?.onChange({
        target: { name, value: val },
      });
    },
  });
};

const SelectablePillsWithLabelAndError = withLabelAndError(
  SelectablePills as WithLabelAndErrorComponent,
);

export default SelectablePillsWithLabelAndError;
export { SelectablePills };
